export default __webpack_public_path__ + "static/media/cm.75758d5f.svg";